import { RouteRecordRaw } from 'vue-router';

// Import composed route modules
import { route as loginRoute } from './login';
import { route as appRoute } from './app';
import { route as adminRoute } from './admin';
import { route as formBuilderRoute } from './form-builder';
import { route as editFormBuilderRoute } from './edit-form-builder';
import { route as editMatrixModelRoute } from './edit-matrix-model';
import { route as notFoundRoute } from './not-found';

export const routes: RouteRecordRaw[] = [
  loginRoute,
  appRoute,
  adminRoute,
  formBuilderRoute,
  editFormBuilderRoute,
  editMatrixModelRoute,
  notFoundRoute,
];
